import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

function Pankuzu(props:any) {
    return(
        <div className='pankuzu'>
            <Link to="/"><span>近藤染工場</span></Link>&emsp;＞&emsp;<Link to="#"><span>{props.pagename}</span></Link>
        </div>
    )
}

export default Pankuzu;